module Meevo.Components.Controls {
    export class MeevoScheduleFrequency implements angular.IDirective {
        restrict = "E";
        scope={
            schedule: "=ngModel"
        }

        templateUrl = "app/components/controls/scheduleFrequencyTemplate.html";
        
        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            }


        static factory(): angular.IDirectiveFactory {
            let directive=() => {
                return new MeevoScheduleFrequency();
            }

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoScheduleFrequency", MeevoScheduleFrequency.factory());
}